import { api, withQuery } from '@/api/client';
import type { ProductListItem } from './types';

export const PRODUCT_COLUMNS = ['产品编号', '产品名称', '分类', '销售参考价', '采购参考价', '瓶重', '瓶高', '瓶身直径', '料色', '口型', '配套盖', '说明', '状态'];
export function downloadProductCsv(name: string, rows: (string | number | null | undefined)[][]) {
  const cell = (value: string | number | null | undefined) => {
    const text = String(value ?? '');
    const safe = typeof value !== 'number' && /^[\s]*[=+\-@]/.test(text) ? `'${text}` : text;
    return `"${safe.replaceAll('"', '""')}"`;
  };
  const url = URL.createObjectURL(new Blob(['\uFEFF', rows.map((row) => row.map(cell).join(',')).join('\r\n')], { type: 'text/csv;charset=utf-8' }));
  const anchor = document.createElement('a'); anchor.href = url; anchor.download = name; anchor.click();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}
export async function exportProducts(path: string, query: Record<string, string | undefined>, signal: AbortSignal, includeCost: boolean) {
  const products = new Map<string, ProductListItem>();
  for (let page = 1; ; page += 1) {
    const result = await api.get<{ items: ProductListItem[]; pagination: { hasNext: boolean; total: number } }>(withQuery(path, { ...query, page, pageSize: 100 }), undefined, signal);
    for (const product of result.items) products.set(product.id, product);
    if (!result.pagination.hasNext) break;
    if (!result.items.length || page >= 1000) throw new Error('产品资料在导出期间变化或数量过多，请缩小筛选后重试');
  }
  if (signal.aborted) return;
  const rows = [...products.values()].map((p) => [p.code, p.name, p.category, p.salePrice, p.purchasePrice, p.bottleWeight, p.bottleHeight, p.bottleDiameter, p.materialColor, p.mouthType, p.matchingCap, p.description, p.isActive ? '启用' : '停用', p.inventorySummary.actualQuantity, p.inventorySummary.reservedQuantity, p.inventorySummary.availableQuantity]);
  const headers = [...PRODUCT_COLUMNS, '现有库存（只读）', '预占库存（只读）', '可用库存（只读）'];
  if (!includeCost) { headers.splice(4, 1); rows.forEach((row) => row.splice(4, 1)); }
  downloadProductCsv(`产品资料-${new Date().toISOString().slice(0, 10)}.csv`, [headers, ...rows]);
  return products.size;
}
